import styled from 'styled-components';

import { FlexColumn } from './FlexColumn';

export const getColor = (props: any) => {
  if (props.isFocused) {
    return props.theme.colors.purple;
  }
  return props.theme.colors.gray;
};

export const DropZone = styled(FlexColumn)`
  text-align: center;
  background-color: ${({ theme }) => theme.colors.white};
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
  border: 2px dashed ${(props) => getColor(props)};
  height: 230px;
  border-radius: 5px;
  width: 100%;
  transition: 0.4s;
`;
